// 数据埋点说明：
// 页面埋点：onUnload或onHide后及停留超过一分钟后进行埋点（为了拿到离开时间）；
// 点击事件埋点：（出现场景：搜索，支付，加购，首页及专题页组件跳转页面。）直接调用publicPage()进行埋点，不需要走该页面逻辑
import dataObj from "../utils/datastatics";
export default {
  beforeDestroy() {
    if (
      this.dataTrackingParams &&
      (this.dataTrackingParams.scene || this.dataTrackingParams.title)
    ) {
      console.log("埋点页面隐藏:", this.dataTrackingParams);
      //埋点
      dataObj.pagePoint();
    }
  },
  mounted() {
    if (this.$route && this.$route.path) {
      if (
        this.dataTrackingParams &&
        (this.dataTrackingParams.scene || this.dataTrackingParams.title)
      ) {
        console.log("埋点页面显示:", this.$route.fullPath);
        // 记录进入页面时间
        this.dataTrackingParams.join_time = Date.now();
        this.dataTrackingParams.web_url = this.$route.fullPath; //当前路由
        // 存储参数
        localStorage.setItem(
          "dataTrackingParams",
          JSON.stringify(this.dataTrackingParams)
        );
        // 清除无操作计时器
        dataObj.clearNoopTimer();
        // 页面加载时开始计时
        dataObj.startNoopTimer();
      }
    }
  },
};
